import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import { isRtlLanguage } from "../utils/rtl";

import {Viewer, Worker, SpecialZoomLevel} from "@react-pdf-viewer/core";
import {zoomPlugin} from "@react-pdf-viewer/zoom";

import backIcon from "../images/back.png";
import ZoomInPdf from "../images/zoom-in.svg";
import ZoomOutPdf from "../images/zoom-out.svg";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "@react-pdf-viewer/print/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

export default function PdfViewer({fileUrl, onBack, backLabel, zoomInLabel, zoomOutLabel}) {
	const zoomPluginInstance = zoomPlugin();
	const {ZoomIn, ZoomOut} = zoomPluginInstance;
	const { language } = useI18next();
	const isRtl = isRtlLanguage(language);
	const iconGap = isRtl ? "mr-1" : "ml-1";
	const btnGap = isRtl ? "mr-4" : "ml-4";

	return (
		<div className={"max-w-full"}>
			<div className={"flex justify-between mb-3"}>
				<button onClick={onBack} className={"flex items-center"} type="button">
					<img
						src={backIcon}
						className={`w-3 h-3 ${isRtl ? "transform rotate-180" : ""}`}
						alt={"back-icon"}
					/>
					<p className={`text-sm text-green ${iconGap} uppercase`}>{backLabel}</p>
				</button>
				<div className={"flex m-0"}>
					<ZoomIn>
						{(props) => (
							<button
								className={`text-green flex self-center ${btnGap}`}
								onClick={props.onClick}
								type="button"
							>
								<img src={ZoomInPdf} alt={"zoom-in-icon"}/>
								<p className={`text-sm ${iconGap} hidden md:block`}>{zoomInLabel}</p>
							</button>
						)}
					</ZoomIn>

					<ZoomOut>
						{(props) => (
							<button
								className={`text-green flex self-center ${btnGap}`}
								onClick={props.onClick}
								type="button"
							>
								<img src={ZoomOutPdf} alt={"zoom-out-icon"}/>
								<p className={`text-sm ${iconGap} hidden md:block`}>{zoomOutLabel}</p>
							</button>
						)}
					</ZoomOut>
				</div>
			</div>
			<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.js">
				<div className={"w-72 sm:w-649 md:w-700 lg:w-900 h-750 m-auto"}>
					<Viewer
						fileUrl={fileUrl}
						defaultScale={SpecialZoomLevel.PageWidth}
						plugins={[zoomPluginInstance]}
					/>
				</div>
			</Worker>
		</div>
	);
}
